import React from 'react';
import PropTypes from 'prop-types';

import PageNumber from './page-number';
import { StyledPagesList } from './styles';
import { useSearchState } from '../../../context';

// Generate array of numbers with "..."
// Page #1 selected:  [1, 2, 3, "...", 20]
// Page #7 selected:  [1, "...", 5, 6, 7, 8, 9, "...", 20]
// Page #20 selected: [1, "...", 18, 19, 20]
const generatePageRange = (current, last) => {
  const delta = 3;
  const start = Math.max(2, current - delta);
  const length = Math.min(last - 1, current + delta);

  const range = [];

  for (let i = start; i <= length; i++) {
    range.push(i);
  }

  if (current - delta > 2) range.unshift('l');
  if (current + delta < last - 1) range.push('r');

  range.unshift(1);
  if (last !== 1) range.push(last);

  return range;
};

// Create Pages based on total amount
const PagesList = () => {
  const { page, pagesTotal, onPageChange } = useSearchState();
  const range = generatePageRange(page, pagesTotal);

  const handlePageChange = (number) => () => {
    onPageChange(number);
  };

  return (
    <StyledPagesList>
      {range.map(number => {
        if (typeof number === 'string') return <span key={number}>...</span>;

        return (
          <PageNumber
            number={number}
            key={number}
            active={number === page}
            onClick={handlePageChange(number)}
          />
        );
      })}
    </StyledPagesList>
  );
};

PagesList.propTypes = {
  pagesTotal: PropTypes.number,
  page: PropTypes.number,
  onChange: PropTypes.func
};

export default PagesList;
